import { Ng1StateDeclaration, Transition } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';
import { IstateDependencyService } from '../../services';

const state = {
    name: 'dataEntry',
    url: '/dataEntry',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve(Roles.manualInputRoles),
        initialDates: Resolve.datesResolve
    },
    data: {
        visible: true,
        isMobileVisible: true,
        sortingOrder: 8,
        displayName: 'Data entry',
        icon: 'fa-keyboard-o',
        editButtonVisibility: () => false,
        subMenu: {
            'type': 'groups',
            subState: 'validation',
            parentName: 'dataEntry'
        },
        subStates: ['logbook', 'manualInputs', 'validation', 'approval', 'spotValues']
    },
    redirectTo: (trans: Transition) => {
        const injector = trans.injector();
        const service: IstateDependencyService = injector.get('stateDependencyService');
        return service
            .getItems(state)
            .then(data => {
                const hasValidation = data.items && data.items.length;
                return hasValidation ? { state: 'validation', params: { groupGuid: data.items[0].guid } } : 'manualInputs';
            }) as any;
    }
};


const states: Ng1StateDeclaration[] = [state];

export default states;